<div class="brand-container">
    <div *ngIf="color" class="color-dot" [style.backgroundColor]="color"></div>
    <span class="brand-name">{{ brand }}</span>
</div>